//TODO: add designs
export const ErrorPage = () => {
  return <p>An error occured</p>;
};
